export default "__VITE_ASSET__DeA8Xku6__"